import { SUPPORTED_MODEL_TYPES } from "src/contexts/_shared/domain/SupportedModelTypes";

export type Model = {
  type: SUPPORTED_MODEL_TYPES;
  year?: number;
  quarter?: Quarter;
  month?: Month;
  licensePlate?: string;
};

export enum Month {
  JANUARY = "01",
  FEBRUARY = "02",
  MARCH = "03",
  APRIL = "04",
  MAY = "05",
  JUNE = "06",
  JULY = "07",
  AUGUST = "08",
  SEPTEMBER = "09",
  OCTOBER = "10",
  NOVEMBER = "11",
  DECEMBER = "12",
}

export enum Quarter {
  FIRST = "Q1",
  SECOND = "Q2",
  THIRD = "Q3",
  FOURTH = "Q4",
}
